export const findDictionaryByID = (id, dictionary) => {
  if (dictionary) {
    return dictionary.find(element => element.id === id).options;
  }

  return []; // sending empty array, for not having a check statement in render (if opportunityGroups exists or not then render)
};